module.exports = __webpack_public_path__ + "media/whatsapp.6e4a04cb.svg";